<template>
  <div>
    <!-- <div class="loader" v-if="this.isLoading"></div>
      <div class="loadertext" v-if="this.isLoading">
        {{ $t("loadingTxt") }}...
      </div> -->
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="Dashboard"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            ">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">

                <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
                                <div class="col-lg-2 col-xl-3 col-sm-3 col-xs-3 col-md-3">
                                    <h4 class="mb-3 mb-md-0">Dashboard Claim</h4>
                                </div>

                                <div class="col-lg-10 col-xl-9 col-sm-9 col-xs-9 col-md-9">
                                    <div class="d-flex flex-wrap">

                                        <div class="input-group flatpickr wd-250 me-2 mb-2 mb-md-0" id="dashboardDate">
                                            <date-range-picker style="width: 100%" @change="loadData"
                                                control-container-class="form-control" :locale-data="locale"
                                                v-model="dateFilter" :opens="opens" :singleDatePicker="false"
                                                :timePicker24Hour="true" :timePicker="true" :showWeekNumbers="false">
                                            </date-range-picker>
                                        </div>

                                       
                                        <div class="input-group flatpickr wd-250 me-2 mb-2 mb-md-0">
                                          <select v-model="branch" class="form-select" aria-label="Default select example">
                                             <option 
                                              v-for="option in this.fetchBranch" 
                                              v-bind:key="option.branch_id"
                                              v-bind:value="option.branch_name"
                                              >{{ option.branch_name }}</option>
                                          </select>
                                        </div>
                                     
                                      


                                        <button type="button" style="max-height: 40px;" @click.prevent="loadData"
                                            class="btn btn-primary btn-icon-text mb-2 mb-md-0 btn-block btn-floating">
                                            GO
                                        </button>
                                        
                                      
                                    </div>
                                </div>


                            </div>

              <div class="card">
               
                <div class="card-body">

                  <div class="row text-center">
                    
                    <div class="col-md-6">
                      <label class="form-label"> <h6>Jumlah Klaim Berdasarkan Status</h6> </label>
                      <div class="d-flex justify-center" style="padding-left:35%;">
                         <pie-chart :chart-data="chartDataStatus" :options="chartOptions"></pie-chart>
                      </div>
                    </div>
                    

                       <div class="col-md-6">
                      <h6>Jumlah Klaim Berdasarkan Kategori</h6>
                      
                      <bar-chart :chart-data="chartDataKategori" :options="chartOptions"></bar-chart>
                    </div>
                       
                  </div>

                  <div class="row " style="margin-top: 20px;">
                    
                   

                    <div class="col-md-6 mb-4">
                      <h6>Akumulasi Klaim Tiap Bulan</h6>
                      
                      <bar-chart :chart-data="chartDataBulanan" :options="chartOptionsHorizontal"></bar-chart>
                    </div>

                     <div class="col-md-6 mb-4">
                      <h6>Sum Of Payment Total</h6>
                      
                      <bar-chart :chart-data="chartDataPayment" :options="chartOptionsHorizontal"></bar-chart>
                    </div>

                  </div>

                  

                  <div class="row " style="margin-top: 20px;">
                    
                   

                    <div class="col-md-6 mb-4">
                      <h6>Sum Of Beban Klaim LINC</h6>
                      
                      <bar-chart :chart-data="chartDataKantor" :options="chartOptionsHorizontal"></bar-chart>
                    </div>


                      <div class="col-md-6 mb-4">
                      <h6>Sum Of Beban Klaim Vendor</h6>
                      
                      <bar-chart :chart-data="chartDataVendor" :options="chartOptionsHorizontal"></bar-chart>
                    </div>
                 
                  </div>


                  <div class="row " style="margin-top: 20px;">
                    
                  

                    <div class="col-md-6 mb-4">
                      <h6>Sum Of Beban Klaim Driver</h6>
                      
                      <bar-chart :chart-data="chartDataDriver" :options="chartOptionsHorizontal"></bar-chart>
                    </div>


                     <div class="col-md-6 mb-4">
                      <h6>Sum Of Beban Klaim Asuransi</h6>
                      
                      <bar-chart :chart-data="chartDataAsuransi"  :options="chartOptionsHorizontal"></bar-chart>
                    </div>

                 
                  </div>


                 
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>

import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from 'moment';
import { Bar, Pie } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
);



export default {
  name: "UserDashboard",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    
    BarChart: {
  extends: Bar,
  props: ["chartData", "options"],
  mounted() {
    this.render();
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.render();
      }
    }
  },
  methods: {
    render() {
      if (this.$data._chart) {
        this.$data._chart.destroy(); // 🔥 WAJIB
      }

      this.renderChart(this.chartData, {
        ...this.options,
        plugins: [ChartDataLabels]
      });
    }
  }
},

    PieChart: Pie,   // langsung pakai dari vue-chartjs
    DateRangePicker
  },
  data() {
    const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
    const endDate = moment().add(1, 'months').calendar();
    return {
            locale: {
          format: "yyyy-mm-dd",
        },
      opens: "center",
      dateFilter: {
          startDate,
          endDate,
      },
      branch:"ALL",
      fetchBranch: [],
      // Grafik Horizontal (Akumulasi klaim per bulan)
      chartDataBulanan: {
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(54,162,235,0.6)",
            borderColor: "rgba(54,162,235,1)",
            borderWidth: 1,
            data: [],
          },
        ],
      },

      chartDataPayment: {
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(204,162,235,0.6)",
            borderColor: "rgba(204,162,235,1)",
            borderWidth: 1,
            data: [],
          },
        ],
      },

      chartDataKantor: {
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(204,255,229,0.6)",
            borderColor: "rgba(204,255,229,1)",
            borderWidth: 1,
            data: [],
          },
        ],
      },

      chartDataAsuransi:{
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(204,255,229,0.6)",
            borderColor: "rgba(204,255,229,1)",
            borderWidth: 1,
            data: [],
          },
        ],
      },

      chartDataVendor: {
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(204,255,229,0.6)",
            borderColor: "rgba(204,255,229,1)",
            borderWidth: 1,
            data: [],
          },
        ],
      },

      chartDataDriver: {
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(204,255,229,0.6)",
            borderColor: "rgba(204,255,229,1)",
            borderWidth: 1,
            data: [],
          },
        ],
      },

      // Grafik Kategori
      chartDataKategori: {
        labels: [],
        datasets: [
          {
            label: "Jumlah",
            backgroundColor: [],
            data: [],
          },
        ],
      },
      // Grafik Status
      chartDataStatus: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: [],
          },
        ],
      },

      // Opsi Chart
      chartOptions: {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: {
        fontColor: "#fff", // warna legend putih
      },
    },
    datalabels: {
      color: "#fff",
      font: {
        weight: "bold",
        size: 14
      },
      anchor: "end",
      align: "top",
      formatter: (value) => {
        return new Intl.NumberFormat("id-ID").format(value);
      }
    }
  },
  scales: {
    xAxes: [
      {
        ticks: {
          fontColor: "#fff", // warna teks sumbu X
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          fontColor: "#fff", // warna teks sumbu Y
        },
      },
    ],
  },
},

      // Opsi khusus Horizontal
chartOptionsHorizontal: {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: {
        color: "#fff" // ✅ v3
      }
    },
    datalabels: {
      color: "#fff",            // PUTIH
      font: {
        weight: "bold",         // BOLD
        size: 14
      },
      anchor: "center",         // 🔥 WAJIB
      align: "center",          // 🔥 WAJIB
      formatter: (value) => {
        return new Intl.NumberFormat("id-ID").format(value);
      }
    }
  },
  scales: {
    x: {
      ticks: {
        color: "#fff"
      }
    },
    y: {
      ticks: {
        color: "#fff"
      }
    }
  }
}


    };
  },
  methods: {

      fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            let rolePermision = [];
            // console.log(userDatas.sub)
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'ClaimDashboardController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

        },


        loadData(){
        this.loadDataByStatus();
        this.loadDataByKategori();
        this.loadDataAkumulasi();
        this.loadDataPayment();
        this.loadDataKantor();
        this.loadDataVendor();
        this.loadDataDriver();
        },

       loadDataByStatus() {
            
            let dataSend = {
                start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'),
                end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
              
            };

            const baseURI = this.$settings.endPoint + "claim/dashboard/by-status?created_at="+ dataSend.start + "~"+ dataSend.end+"&branch="+this.branch.toLowerCase(); // ?start=" + dataSend.start + "&end=" + dataSend.end
            this.$http
                .post(baseURI,dataSend, { timeout: 10000 })
                .then((response) => {
                    this.isLoading = false;
                    if (response.status == 200) {
                     

                       let summary = response.data.datas.summary;

                            let labels = Object.keys(summary); // ["PENGAJUAN","BARU"]
                            let totals = Object.values(summary).map(item => item.count);
                       
                            // generate random colors sesuai jumlah data
                            let colors = labels.map(() => {
                              return `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
                            });

                            this.chartDataStatus = {
                              labels: labels,
                              datasets: [
                                {
                                  label: "Jumlah Klaim",
                                  data: totals,
                                  backgroundColor: colors
                                }
                              ]
                            };


                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 500) {
                                this.error(error.response.data.errors.message);
                            } else {
                                //this.$router.push("/page-not-found");
                            }
                        }

                    }


                });

        },


        loadDataByKategori() {
            
            let dataSend = {
                start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'),
                end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
              
            };

            const baseURI = this.$settings.endPoint + "claim/dashboard/by-kategori?created_at="+ dataSend.start + "~"+ dataSend.end+"&branch="+this.branch.toLowerCase(); // ?start=" + dataSend.start + "&end=" + dataSend.end
            this.$http
                .post(baseURI,dataSend, { timeout: 10000 })
                .then((response) => {
                    this.isLoading = false;
                    if (response.status == 200) {
                     

                       let summary = response.data.datas.summary;

                            let labels = Object.keys(summary); // ["PENGAJUAN","BARU"]
                            let counts = Object.values(summary).map(item => item.count);

                            // generate random colors sesuai jumlah data
                            let colors = labels.map(() => {
                              return `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
                            });

                            this.chartDataKategori={
                              labels: labels,
                              datasets: [
                                {
                                  label: "Jumlah",
                                  backgroundColor: colors,
                                  data: counts,
                                },
                              ],
                            }


                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 500) {
                                this.error(error.response.data.errors.message);
                            } else {
                                //this.$router.push("/page-not-found");
                            }
                        }

                    }


                });

        },


        loadDataAkumulasi() {
            
            let dataSend = {
                start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'),
                end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
              
            };

            const baseURI = this.$settings.endPoint + "claim/dashboard/by-claim-total-month?created_at="+ dataSend.start + "~"+ dataSend.end+"&branch="+this.branch.toLowerCase(); // ?start=" + dataSend.start + "&end=" + dataSend.end
            this.$http
                .post(baseURI,dataSend, { timeout: 10000 })
                .then((response) => {
                    this.isLoading = false;
                    if (response.status == 200) {
                     

                       let summary = response.data.datas.summary;

                            let labels = Object.keys(summary); // ["PENGAJUAN","BARU"]
                            let totals = Object.values(summary).map(item => item.total);

                            // generate random colors sesuai jumlah data
                            let colors = labels.map(() => {
                              return `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
                            });

                         this.chartDataBulanan= {
                            labels: labels,
                            datasets: [
                              {
                                label: "Akumulasi Klaim",
                                backgroundColor: colors,
                                borderColor: "rgba(54,162,235,1)",
                                borderWidth: 1,
                                data: totals,
                              },
                            ],
                          }


                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 500) {
                                this.error(error.response.data.errors.message);
                            } else {
                                //this.$router.push("/page-not-found");
                            }
                        }

                    }


                });

        },


        loadDataPayment() {
            
            let dataSend = {
                start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'),
                end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
              
            };

            const baseURI = this.$settings.endPoint + "claim/dashboard/by-total-payment?created_at="+ dataSend.start + "~"+ dataSend.end+"&branch="+this.branch.toLowerCase();// ?start=" + dataSend.start + "&end=" + dataSend.end
            this.$http
                .post(baseURI,dataSend, { timeout: 10000 })
                .then((response) => {
                    this.isLoading = false;
                    if (response.status == 200) {
                     

                       let summary = response.data.datas.summary;

                            let labels = Object.keys(summary); // ["PENGAJUAN","BARU"]
                            let totals = Object.values(summary).map(item => item.total);

                            // generate random colors sesuai jumlah data
                            let colors = labels.map(() => {
                              return `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
                            });

                         this.chartDataPayment= {
                            labels: labels,
                            datasets: [
                              {
                                label: "Sum Total Payment",
                                backgroundColor: colors,
                                borderColor: "rgba(54,162,235,1)",
                                borderWidth: 1,
                                data: totals,
                              },
                            ],
                          }


                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 500) {
                                this.error(error.response.data.errors.message);
                            } else {
                                //this.$router.push("/page-not-found");
                            }
                        }

                    }


                });

        },


        loadDataKantor() {
            
            let dataSend = {
                start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'),
                end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
              
            };

            const baseURI = this.$settings.endPoint + "claim/dashboard/by-claim-kantor?created_at="+ dataSend.start + "~"+ dataSend.end+"&branch="+this.branch.toLowerCase();// ?start=" + dataSend.start + "&end=" + dataSend.end
            this.$http
                .post(baseURI,dataSend, { timeout: 10000 })
                .then((response) => {
                    this.isLoading = false;
                    if (response.status == 200) {
                     

                       let summary = response.data.datas.summary;

                            let labels = Object.keys(summary); // ["PENGAJUAN","BARU"]
                            let totals = Object.values(summary).map(item => item.total);

                            // generate random colors sesuai jumlah data
                            let colors = labels.map(() => {
                              return `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
                            });

                         this.chartDataKantor= {
                            labels: labels,
                            datasets: [
                              {
                                label: "Sum Of Beban Klaim LINC",
                                backgroundColor: colors,
                                borderColor: "rgba(204,255,229,1)",
                                borderWidth: 1,
                                data: totals,
                              },
                            ],
                          }


                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 500) {
                                this.error(error.response.data.errors.message);
                            } else {
                                //this.$router.push("/page-not-found");
                            }
                        }

                    }


                });

        },




        loadDataAsuransi() {
            
            let dataSend = {
                start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'),
                end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
              
            };

            const baseURI = this.$settings.endPoint + "claim/dashboard/by-claim-insurance?created_at="+ dataSend.start + "~"+ dataSend.end+"&branch="+this.branch.toLowerCase();// ?start=" + dataSend.start + "&end=" + dataSend.end
            this.$http
                .post(baseURI,dataSend, { timeout: 10000 })
                .then((response) => {
                    this.isLoading = false;
                    if (response.status == 200) {
                     

                       let summary = response.data.datas.summary;

                            let labels = Object.keys(summary); // ["PENGAJUAN","BARU"]
                            let totals = Object.values(summary).map(item => item.total);

                            // generate random colors sesuai jumlah data
                            let colors = labels.map(() => {
                              return `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
                            });

                         this.chartDataAsuransi= {
                            labels: labels,
                            datasets: [
                              {
                                label: "Sum Of Beban Klaim Asuransi",
                                backgroundColor: colors,
                                borderColor: "rgba(204,255,229,1)",
                              
                                borderWidth: 1,
                                data: totals,

                                 font: {
        weight: "bold",         // BOLD
        size: 14
      },
      anchor: "center",         // 🔥 WAJIB
      align: "center",          // 🔥 WAJIB
      formatter: (value) => {
        return new Intl.NumberFormat("id-ID").format(value);
      }
                              },

                            ],
                            
                          }


                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 500) {
                                this.error(error.response.data.errors.message);
                            } else {
                                //this.$router.push("/page-not-found");
                            }
                        }

                    }


                });

        },





        loadDataVendor() {
            
            let dataSend = {
                start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'),
                end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
              
            };

            const baseURI = this.$settings.endPoint + "claim/dashboard/by-claim-vendor?created_at="+ dataSend.start + "~"+ dataSend.end+"&branch="+this.branch.toLowerCase();// ?start=" + dataSend.start + "&end=" + dataSend.end
            this.$http
                .post(baseURI,dataSend, { timeout: 10000 })
                .then((response) => {
                    this.isLoading = false;
                    if (response.status == 200) {
                     

                       let summary = response.data.datas.summary;

                            let labels = Object.keys(summary); // ["PENGAJUAN","BARU"]
                            let totals = Object.values(summary).map(item => item.total);

                            // generate random colors sesuai jumlah data
                            let colors = labels.map(() => {
                              return `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
                            });

                         this.chartDataVendor= {
                            labels: labels,
                            datasets: [
                              {
                                label: "Sum Of Beban Klaim Vendor",
                                backgroundColor: colors,
                                borderColor: "rgba(204,255,229,1)",
                                borderWidth: 1,
                                data: totals,
                              },
                            ],
                          }


                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 500) {
                                this.error(error.response.data.errors.message);
                            } else {
                                //this.$router.push("/page-not-found");
                            }
                        }

                    }


                });

        },



        loadDataDriver() {
            
            let dataSend = {
                start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'),
                end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
              
            };

            const baseURI = this.$settings.endPoint + "claim/dashboard/by-claim-driver?created_at="+ dataSend.start + "~"+ dataSend.end+"&branch="+this.branch.toLowerCase();// ?start=" + dataSend.start + "&end=" + dataSend.end
            this.$http
                .post(baseURI,dataSend, { timeout: 10000 })
                .then((response) => {
                    this.isLoading = false;
                    if (response.status == 200) {
                     

                       let summary = response.data.datas.summary;

                            let labels = Object.keys(summary); // ["PENGAJUAN","BARU"]
                            let totals = Object.values(summary).map(item => item.total);

                            // generate random colors sesuai jumlah data
                            let colors = labels.map(() => {
                              return `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
                            });

                         this.chartDataDriver= {
                            labels: labels,
                            datasets: [
                              {
                                label: "Sum Of Beban Klaim Driver",
                                backgroundColor: colors,
                                borderColor: "rgba(204,255,229,1)",
                                borderWidth: 1,
                                data: totals,
                              },
                            ],
                          }


                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 500) {
                                this.error(error.response.data.errors.message);
                            } else {
                                //this.$router.push("/page-not-found");
                            }
                        }

                    }


                });

        },

      loadBranch() {
        const baseURI = this.$settings.endPointCt + `branch/select`;

        return this.$http.get(baseURI).then((response) => {
          this.fetchBranch = response.data.datas.data;
          const newItem = { branch_id: this.fetchBranch.length + 1, branch_name: 'ALL' };
          this.fetchBranch.push(newItem);
        });


      },

 

  },
   mounted() {
        this.fetchIt();
        this.loadDataByStatus();
        this.loadDataByKategori();
        this.loadDataAkumulasi();
        this.loadDataPayment();
        this.loadDataKantor();
        this.loadDataVendor();
        this.loadDataDriver();
        this.loadBranch();
        this.loadDataAsuransi();
       
    },
};



</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content {
  filter: blur(5px);
}
</style>